<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Page',
})
</script>
<template>
  <div>
        <section class="bg-img" v-for="(item,i) in pageData.child" :key="i" :class="item.classname" :style="{backgroundColor:item.background,backgroundImage:'url('+addip(item.backgroundimg)+')',color:item.color}">
          <div :class="item.fullwidth>0?'full-container':'auto-container'">
            <component :is="resolveComponent(item.classname)" :data="item"></component>
          </div>
        </section>
  </div>
</template>

<script lang="ts" setup name="Page">
import { onMounted, ref,resolveComponent } from 'vue';
import { useRoute } from 'vue-router';
import api from '@/utils/http/service';
import {addip} from '@/utils/util'
import { onBeforeMount } from 'vue';
import useSiteSettings from '@/store/useSiteSettings'
  const {  device } = useSiteSettings()
  const route = useRoute();
  const id = ref(route.query.id);
  const pageData=ref<Object>({})
  onMounted(()=>{
      api.sitepage.page(route.query).then(res=>{
            pageData.value=res.data
            document.title=res.data.name
            var root=document.getElementById('pages')
            if(res.data.classname&&res.data.classname!='dark'){
                root.classList.remove('dark')
                root.classList.add(res.data.classname)
            }
      })
  })
</script>
